import React from 'react';

export const LoginCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return <div className="login-card">{children}</div>;
};
